module.exports = __webpack_public_path__ + "img/music-player-pause.481eb850.svg";